<template>
<gallery-Images-Search :isDocument ="isDocument" :cols="cols" :placeholderName="placeholderName"/>
</template>
<script>
import galleryImagesSearch from '../galleryImagesStep/galleryImagesSearch.vue';
export default {
  props:['cols','placeholderName','isDocument'],
  components: {
    galleryImagesSearch
  }
};
</script>
